import {
  CIVILBUDGETCONTROL_LOADING,
  GET_CIVILBUDGETCONTROL,
  GET_CIVILBUDGETCONTROL_SUCCESS,
  GET_CIVILBUDGETCONTROL_FAIL,
  ADD_CIVILBUDGETCONTROL_SUCCESS,
  ADD_CIVILBUDGETCONTROL_FAIL,
  DELETE_CIVILBUDGETCONTROL_SUCCESS,
  DELETE_CIVILBUDGETCONTROL_FAIL,
  UPDATE_CIVILBUDGETCONTROL_SUCCESS,
  UPDATE_CIVILBUDGETCONTROL_FAIL,
  CIVILBUDGETCONTROL_RESET
} from "./actionType";

const INIT_STATE = {
  civilBudgetControls: [],
  error: {},
};

const CivilBudgetControl = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CIVILBUDGETCONTROL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CIVILBUDGETCONTROL:
          return {
            ...state,
            civilBudgetControls: action.payload.data,
            isCivilBudgetControlCreated: false,
            isCivilBudgetControlSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_CIVILBUDGETCONTROL_FAIL:
      switch (action.payload.actionType) {
        case GET_CIVILBUDGETCONTROL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isCivilBudgetControlCreated: false,
            isCivilBudgetControlSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_CIVILBUDGETCONTROL: {
      return {
        ...state,
        isCivilBudgetControlCreated: false,
        loading: true,
      };
    }

    case CIVILBUDGETCONTROL_LOADING: {
      return {
        ...state,
        isCivilBudgetControlCreated: false,
        loading: true,
      };
    }

    case ADD_CIVILBUDGETCONTROL_SUCCESS:
      return {
        ...state,
        isCivilBudgetControlCreated: true,
        loading: false,
        civilBudgetControls: [action.payload.data, ...state.civilBudgetControls],
      };

    case ADD_CIVILBUDGETCONTROL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CIVILBUDGETCONTROL_SUCCESS:
      return {
        ...state,
        loading: false,
        civilBudgetControls: state.civilBudgetControls.filter(
          civilCivilBudgetControl => civilCivilBudgetControl.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_CIVILBUDGETCONTROL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_CIVILBUDGETCONTROL_SUCCESS:
      return {
        ...state,
        loading: false,
        civilBudgetControls: state.civilBudgetControls.map(civilCivilBudgetControl =>
          civilCivilBudgetControl.id.toString() === action.payload.data.id.toString() ? { ...civilCivilBudgetControl, ...action.payload.data } : civilCivilBudgetControl
        ),
      };

    case UPDATE_CIVILBUDGETCONTROL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CIVILBUDGETCONTROL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default CivilBudgetControl;